import { type AssetRetrievalType, isAssetRetrievalOrder, isAssetRetrievalQuotation } from '@repo/types/asset-retrieval';

export const selectAssetRetrievalCustomerId = (asset: AssetRetrievalType) => {
    if (isAssetRetrievalOrder(asset)) {
        return asset.customerBilling?.partyId;
    }

    if (isAssetRetrievalQuotation(asset)) {
        return asset.customerIdentifier?.id;
    }

    return asset.customerInfo?.id;
};
